import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import { ErroHttp } from "./api/cliente";
import { AuthProvider } from "./auth/AuthProvider";
import { AvisosProvider } from "./components/Avisos";
import { Layout, LayoutSemMoldura, RotaAdmin } from "./components/Layout";
import { ContaSenha, EsqueciSenha, Login, Registrar } from "./pages/Acesso";
import { Itens } from "./pages/Itens";
import { Municipios } from "./pages/Municipios";
import { OrcamentoCompor } from "./pages/OrcamentoCompor";
import { OrcamentoDetalhe } from "./pages/OrcamentoDetalhe";
import { OrcamentoImprimir } from "./pages/OrcamentoImprimir";
import { OrcamentoCanteiro } from "./pages/OrcamentoCanteiro";
import { OrcamentoCronograma, OrcamentoCurvaAbc } from "./pages/OrcamentoPlanejamento";
import { OrcamentoModeloDetalhe, OrcamentoModelos } from "./pages/OrcamentoModelos";
import { OrcamentoNovo, OrcamentosLista } from "./pages/Orcamentos";
import { Painel } from "./pages/Painel";
import { Usuarios } from "./pages/Usuarios";
import "./styles/style.css";
import "./styles/complemento.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (tentativas, erro) => !(erro instanceof ErroHttp && erro.status < 500) && tentativas < 2,
    },
  },
});

/** Cada tela nova começa no topo (no celular, a tela de entrar fica rolada por causa do teclado). */
function RolarAoTopo() {
  const { pathname } = useLocation();
  useEffect(() => {
    (document.activeElement as HTMLElement | null)?.blur?.();
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NaoEncontrado() {
  return (
    <>
      <h1>Página não encontrada</h1>
      <p className="note">
        <Link to="/">Voltar ao painel</Link>
      </p>
    </>
  );
}

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RolarAoTopo />
        <AvisosProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/registrar" element={<Registrar />} />
              <Route path="/esqueci-senha" element={<EsqueciSenha />} />
              <Route element={<LayoutSemMoldura />}>
                <Route path="/orcamentos/:id/imprimir" element={<OrcamentoImprimir />} />
              </Route>
              <Route element={<Layout />}>
                <Route index element={<Painel />} />
                <Route path="/itens" element={<Itens />} />
                <Route path="/municipios" element={<Municipios />} />
                <Route path="/orcamentos" element={<OrcamentosLista />} />
                <Route path="/orcamentos/novo" element={<OrcamentoNovo />} />
                <Route path="/orcamentos/:id" element={<OrcamentoDetalhe />} />
                <Route path="/orcamentos/:id/compor" element={<OrcamentoCompor />} />
                <Route path="/orcamentos/:id/canteiro" element={<OrcamentoCanteiro />} />
                <Route path="/orcamentos/:id/curva-abc" element={<OrcamentoCurvaAbc />} />
                <Route path="/orcamentos/:id/cronograma" element={<OrcamentoCronograma />} />
                <Route path="/orcamentos/:id/modelos" element={<OrcamentoModelos />} />
                <Route path="/orcamentos/:id/modelos/:modeloId" element={<OrcamentoModeloDetalhe />} />
                <Route path="/conta/senha" element={<ContaSenha />} />
                <Route element={<RotaAdmin />}>
                  <Route path="/usuarios" element={<Usuarios />} />
                </Route>
                <Route path="*" element={<NaoEncontrado />} />
              </Route>
            </Routes>
          </AuthProvider>
        </AvisosProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
